import Description from './Description';
import Description2 from './Description2';


const Main = () => {
    return ( <div className="main">
        <Description />
        <Description2 />
    </div> );
}
 
export default Main;